<template>
  <base-section id="organizing-committee">
    <base-section-heading title="Organizing Committee" />

    <v-container>
      <v-row>
        <base-avatar-card
          title="General Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(general, i) in generals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="general"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Program Chair"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in programs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Publicity Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(publicity, i) in publicities"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="publicity"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Regional Liaison Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(regional, i) in regionals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="regional"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Virtualization Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(virtual, i) in virtuals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="virtual"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Web Resource Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(web, i) in webs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="web"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'OrganizingCommittee',

    data: () => ({
      generals: [
        {
          title: 'Paolo Bernardi',
          src: require('@/images/committees/paolobernardi.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Daniel Tille',
          src: require('@/images/committees/danieltille.jpg'),
          text: 'Infineon, DE',
        },
      ],
      programs: [
        {
          title: 'Alberto Bosio',
          src: require('@/images/committees/albertobosio.jpg'),
          text: 'Ecole Central de Lyon, FR',
        },
      ],
      publicities: [
        {
          title: 'Alexandra Kourfali',
          src: require('@/images/committees/alexandrakourfali.jpg'),
          text: 'ITI Stuttgart, DE',
        },
        {
          title: 'Giorgio Di Natale',
          src: require('@/images/committees/giorgiodinatale.jpg'),
          text: 'TIMA, FR',
        },
      ],
      regionals: [
        {
          title: 'Sule Ozev',
          src: require('@/images/committees/suleozev.jpg'),
          text: 'Arizona State University, USA',
        },
        {
          title: 'Ernesto Sanchez',
          src: require('@/images/committees/ernestosanchez.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      virtuals: [
        {
          title: 'Stefano Di Carlo',
          src: require('@/images/committees/stefanodicarlo.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Tommaso Foscale',
          src: require('@/images/committees/tommasofoscale.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      webs: [
        {
          title: 'Giusy Iaria',
          src: require('@/images/committees/giusyiaria.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Nicolò Bellarmino',
          src: require('@/images/committees/nicolobellarmino.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Andrea Calabrese',
          src: require('@/images/committees/andreacalabrese.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Gabriele Filipponi',
          src: require('@/images/committees/gabrielefilipponi.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Francesco Angione',
          src: require('@/images/committees/francescoangione.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
    }),
  }
</script>
